var _g, _path, _g2, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgActivityCheck = function SvgActivityCheck(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 108,
    viewBox: "0 0 96 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10345_110514)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.8216 60.4767C47.3961 60.1776 48.0797 60.1753 48.6562 60.4703L75.5213 74.2196C76.973 74.9626 76.973 77.0374 75.5213 77.7804L48.6562 91.5297C48.0797 91.8247 47.3961 91.8224 46.8216 91.5233L20.4081 77.774C18.9727 77.0269 18.9727 74.9731 20.4081 74.226L46.8216 60.4767Z",
    fill: "black",
    fillOpacity: 0.01
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10345_110514",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 12,
    width: 63,
    height: 72
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.1769 13.1547C47.4145 12.4402 48.9393 12.4402 50.1769 13.1547L77.3538 28.8453C78.5914 29.5598 79.3538 30.8803 79.3538 32.3094V63.6906C79.3538 65.1197 78.5914 66.4402 77.3538 67.1547L50.1769 82.8453C48.9393 83.5598 47.4145 83.5598 46.1769 82.8453L19.0008 67.1547C17.7633 66.4402 17.0009 65.1197 17.0008 63.6907L17.0001 32.3095C17 30.8804 17.7624 29.5598 19.0001 28.8453L46.1769 13.1547Z",
    fill: "#C4C4C4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10345_110514)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 48.2139 12)",
    fill: "url(#paint0_linear_10345_110514)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -2.98023e-8,
    y: 0.5,
    width: 35,
    height: 35,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 48.6469 12.25)",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "matrix(0.866025 -0.5 2.20305e-08 1 48.2139 48)",
    fill: "url(#paint1_linear_10345_110514)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.433013,
    y: 0.25,
    width: 35,
    height: 35,
    transform: "matrix(0.866025 -0.5 2.20305e-08 1 48.2719 48.2165)",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9091 51.8586L68.2734 53.3803C68.1466 53.4538 68.0226 53.5679 67.9163 53.7089C67.8099 53.85 67.7257 54.0119 67.6738 54.1754L65.7826 60.1445L62.9756 50.1466C62.9397 50.0156 62.8641 49.9241 62.759 49.8847C62.6539 49.8453 62.5246 49.86 62.3888 49.9268C62.2529 49.9935 62.1173 50.109 62.0006 50.2574C61.8838 50.4058 61.7917 50.5797 61.7368 50.7553L59.279 58.5733L57.0715 59.8477C56.8968 59.9486 56.7292 60.1255 56.6056 60.3396C56.482 60.5536 56.4126 60.7872 56.4126 60.989C56.4126 61.1908 56.482 61.3443 56.6056 61.4156C56.7292 61.487 56.8968 61.4704 57.0715 61.3695L59.7073 59.8477C59.834 59.7742 59.958 59.6601 60.0644 59.5191C60.1707 59.3781 60.2549 59.2161 60.3069 59.0526L62.198 53.0836L64.9985 63.1233C65.0348 63.2534 65.1106 63.344 65.2156 63.3829C65.3205 63.4217 65.4495 63.4067 65.5849 63.3401L65.6311 63.3135C65.7578 63.24 65.8818 63.1259 65.9882 62.9849C66.0945 62.8438 66.1787 62.6819 66.2307 62.5184L68.7017 54.6548L70.9091 53.3803C71.0839 53.2794 71.2515 53.1025 71.375 52.8885C71.4986 52.6744 71.568 52.4408 71.568 52.239C71.568 52.0372 71.4986 51.8838 71.375 51.8124C71.2515 51.7411 71.0839 51.7577 70.9091 51.8586Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "matrix(0.866025 0.5 -2.20305e-08 1 17.0381 30)",
    fill: "url(#paint2_linear_10345_110514)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.433013,
    y: 0.75,
    width: 35,
    height: 35,
    transform: "matrix(0.866025 0.5 -2.20305e-08 1 17.0961 29.7835)",
    stroke: "white",
    strokeOpacity: 0.4
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6769 14.0207C47.6051 13.4848 48.7487 13.4848 49.6769 14.0207L76.8538 29.7113C77.782 30.2472 78.3538 31.2376 78.3538 32.3094V63.6906C78.3538 64.7624 77.782 65.7528 76.8538 66.2887L49.6769 81.9793C48.7487 82.5152 47.6051 82.5152 46.6769 81.9792L19.5008 66.2887C18.5727 65.7528 18.0009 64.7624 18.0008 63.6907L18.0001 32.3094C18 31.2376 18.5718 30.2472 19.5001 29.7113L46.6769 14.0207Z",
    stroke: "white",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10345_110514",
    x: 3.33154,
    y: 44.2507,
    width: 89.2786,
    height: 63.4985,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0392157 0 0 0 0 0.772549 0 0 0 0 0.447059 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10345_110514"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_10345_110514",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10345_110514",
    x1: -0.267884,
    y1: 0.267885,
    x2: 35.7321,
    y2: 0.267886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FF3C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39D98A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10345_110514",
    x1: -0.535769,
    y1: -0.267884,
    x2: 36.8338,
    y2: -0.136971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DDC8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0CC573"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10345_110514",
    x1: 17.2767,
    y1: -10.1384,
    x2: 43.4682,
    y2: -1.59252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EDD8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06C270"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgActivityCheck);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "activity_check.ea6f8d6fadbf0ccb56b837f9c7a3e5b2.svg";